import { createSelector } from "@ngrx/store";
import semver from "semver";

import { AppDetailsState } from "../reducers/data/app-details.reducer";
import { CordovaService, IcCordovaPlatform } from "../../modules/cordova/cordova.service";
import { selectDataSlice } from "./data-slice.selector";

export const selectAppDetails = createSelector(selectDataSlice, (state) => state.appDetails);

export const selectLatestAppVersion = createSelector(
	selectAppDetails,
	(state: AppDetailsState) => state.latestAppVersion,
);

export const selectIsAppVersionOutdated = (version: string) =>
	createSelector(selectLatestAppVersion, (latestMedappVersion) => {
		if (latestMedappVersion) {
			let latestVersion: string;
			switch (CordovaService.getPlatform()) {
				case IcCordovaPlatform.ANDROID: {
					latestVersion = latestMedappVersion["medapp-android"];
					break;
				}
				case IcCordovaPlatform.IOS: {
					latestVersion = latestMedappVersion["medapp-ios"];
					break;
				}
				case IcCordovaPlatform.BROWSER: {
					latestVersion = latestMedappVersion["medapp-browser"];
					break;
				}
				default: {
					return true;
				}
			}
			return semver.gt(latestVersion, version);
		} else {
			return false;
		}
	});
